import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Erro from "../views/Erro";
import Success from "../views/Success";
import Expirado from "../views/Expirado";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:cpfCnpj/:numPedido",
    name: "HomeAfv",
    component: Home,
  },
  {
    path: "/error",
    name: "Error",
    component: Erro,
  },

  {
    path: "/success",
    name: "Success",
    component: Success,
  },
  {
    path: "/expirado",
    name: "Expirado",
    component: Expirado,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
